import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderSupplyList extends BaseModelAPI {

	static entity = 'workordersupplylist'
	static entityName = 'workordersupply';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
